@if (useDateTimeFormat) {
  @if (control) {
    <mat-form-field
      appearance="outline"
      class="ui-datepicker-field ui-form-field-v2"
      [class.ui-datepicker-open]="picker.opened"
      [subscriptSizing]="
        subscriptSizing || (description || omitErrorKeys.length ? 'dynamic' : 'fixed')
      "
    >
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <input
        matInput
        [min]="min"
        [max]="max"
        [placeholder]="placeholder"
        [ngxMatDatetimePicker]="picker"
        [formControl]="control"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        (dateChange)="changeHandler.emit($event)"
        [tabIndex]="tabIndex"
      />
      <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
      <ngx-mat-datetime-picker
        #picker
        panelClass="app-ui-datepicker-panel"
        [showSpinners]="false"
        [enableMeridian]="false"
        [defaultTime]="initialTime"
        (opened)="setOpenedDate(picker)"
      ></ngx-mat-datetime-picker>
      @if (description) {
        <mat-hint>{{ description }}</mat-hint>
      }
      @let errorText = control.errors | joinErrorMessages: messages : omitErrorKeys;
      @if (errorText) {
        <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
      }
    </mat-form-field>
  }
} @else {
  @if (control) {
    <mat-form-field
      appearance="outline"
      class="ui-datepicker-field ui-form-field-v2"
      [class.ui-datepicker-open]="picker.opened"
      [subscriptSizing]="
        subscriptSizing || (description || omitErrorKeys.length ? 'dynamic' : 'fixed')
      "
    >
      @if (label) {
        <mat-label>{{ label }}</mat-label>
      }
      <input
        matInput
        [min]="min"
        [max]="max"
        [placeholder]="placeholder"
        [matDatepicker]="picker"
        [formControl]="control"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        (dateChange)="changeHandler.emit($event)"
        [tabIndex]="tabIndex"
      />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker type="datetime" panelClass="app-ui-datepicker-panel"></mat-datepicker>
      @if (description) {
        <mat-hint>{{ description }}</mat-hint>
      }
      @let errorText = control.errors | joinErrorMessages: messages : omitErrorKeys;
      @if (errorText) {
        <mat-error [attr.title]="errorText">{{ errorText }}</mat-error>
      }
    </mat-form-field>
  }
}
